import { Action as TrendsAction } from '../actions/trends';
import { Action as StationInfoAction } from '../actions/station-info';
import { trendToTrendWord } from '../../lib/utils';

const defaultState = {
  isFetching: false,
};

export default function trendsReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case StationInfoAction.StationInfo.StationSearchCompleted:
    case TrendsAction.Trends.TrendCompleted:
      if (body.trends?.length) {
        const trendData = body.trends[0];
        const average = trendData.Today;
        const lowest = trendData.TodayLow;
        const areaName = trendData.AreaName;
        const direction = trendToTrendWord(trendData.Trend);

        return {
          ...state,
          isFetching: false,
          [body.trendsKey]: {
            areaName,
            average,
            lowest,
            direction,
          },
        };
      }

      return {
        ...state,
        isFetching: false,
      };

    case StationInfoAction.StationInfo.StationSearchPending:
    case TrendsAction.Trends.TrendPending:
      return {
        ...state,
        isFetching: true,
      };

    default:
      return state;
  }
}
